import { render, staticRenderFns } from "./TeachingDetail.vue?vue&type=template&id=10d3fc42&scoped=true&"
import script from "./TeachingDetail.vue?vue&type=script&lang=js&"
export * from "./TeachingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeachingDetail.vue?vue&type=style&index=0&id=10d3fc42&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3fc42",
  null
  
)

export default component.exports